import React from "react";
import "./LecturerDashboard.css";
import { Button, Card, Col, Container, Row, Table } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faChevronLeft,
  faFileContract,
  faFileSignature, faLink,
  faUser,
  faUserTag
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

class LecturerDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      videoCollapsable: Array(6).fill(true)
    };

  }


  render() {
    const { t } = this.props;
    const openExaminations = this.props.examinations.filter(
      ex => ex.status === 11
    );
    return (
      <Container className="ml-0 mr-0 pl-0 pr-0">
        <Row>
          <Col>
            <Card>
              <Card.Body>
                <div className="dashboard-label">
                  <b>{t("Dashboard.LecturerDashboard.Classes")}</b>
                </div>
                <Container>
                  <Row>
                    <Col>
                      <FontAwesomeIcon
                        icon={faUser}
                        className="dashboard-icon color-green"
                      />
                    </Col>
                    <Col>
                      <div className="floatRight dashboard-value">
                        <span>{this.props.classesCount}</span>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </Card.Body>
            </Card>
          </Col>
          <Col>
            <Card>
              <Card.Body>
                <div className="dashboard-label">
                  <b>{t("Dashboard.LecturerDashboard.ModuleClasses")}</b>
                </div>
                <Container>
                  <Row>
                    <Col>
                      <FontAwesomeIcon
                        icon={faUserTag}
                        className="dashboard-icon color-green"
                      />
                    </Col>
                    <Col>
                      <div className="floatRight dashboard-value">
                        <span>{this.props.moduleClasses.length}</span>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </Card.Body>
            </Card>
          </Col>
          <Col>
            <Card>
              <Card.Body>
                <div className="dashboard-label">
                  <b>{t("Dashboard.LecturerDashboard.Examinations")}</b>
                </div>
                <Container>
                  <Row>
                    <Col>
                      <FontAwesomeIcon
                        icon={faFileContract}
                        className="dashboard-icon color-green"
                      />
                    </Col>
                    <Col>
                      <div className="floatRight dashboard-value">
                        <span>{this.props.examinations.length}</span>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </Card.Body>
            </Card>
          </Col>
          <Col>
            <Card>
              <Card.Body>
                <div className="dashboard-label">
                  <b>{t("Dashboard.LecturerDashboard.OpenExaminations")}</b>
                </div>
                <Container>
                  <Row>
                    <Col>
                      <FontAwesomeIcon
                        icon={faFileSignature}
                        className="dashboard-icon color-green"
                      />
                    </Col>
                    <Col>
                      <div className="floatRight dashboard-value">
                        <span>{openExaminations.length}</span>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col>
            <Card>
              <Card.Body>
                <h4>{t("Dashboard.LecturerDashboard.OpenExaminations")}</h4>
                <Table className="mt-2">
                  <thead>
                  <tr>
                    <th>{t("Dashboard.LecturerDashboard.ColumnName")}</th>
                    <th>
                      {t("Dashboard.LecturerDashboard.ColumnModuleName")}
                    </th>
                    <th>
                      {t("Dashboard.LecturerDashboard.ColumnClassName")}
                    </th>
                    <th>
                      {t("Dashboard.LecturerDashboard.ColumnInstancesCount")}
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  {openExaminations.length > 0 ? (
                    openExaminations.map(ex => (
                      <tr>
                        <td>
                          <Link
                            className="item-link"
                            to={{
                              pathname: `/examinations/${ex._id}`,
                              state: { examination: ex }
                            }}
                          >
                            {ex.name}
                          </Link>
                        </td>
                        <td>{ex.moduleName}</td>
                        <td>{ex.className}</td>
                        <td>{ex.instancesCount}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4">
                        {t("Dashboard.LecturerDashboard.NoOpenExamination")}
                      </td>
                    </tr>
                  )}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col>
            <Card>
              <Card.Body>
                <h4>{t("Dashboard.LecturerDashboard.GetStarted.Title")}</h4>
                <Table>
                  <tbody>
                  <tr>
                    <td width="80px">
                      <img
                          alt={t(
                              "Dashboard.LecturerDashboard.GetStarted.FirstExamination.Title"
                          )}
                          src="/images/example/campla.png"
                      />
                    </td>
                    <td>
                      <b>
                        {t(
                          "Dashboard.LecturerDashboard.GetStarted.FirstExamination.Title"
                        )}
                      </b>
                      <p>
                        {t(
                          "Dashboard.LecturerDashboard.GetStarted.FirstExamination.Description"
                        )}
                      </p>
                    </td>
                    <td width="50px">
                      <a href={window.helpVideos.lecturer.firstExamination} target="_blank">
                        <Button
                            className="btn btn-green"
                            size="sm"
                        >
                          <FontAwesomeIcon icon={faLink} />
                        </Button>
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td width="80px">
                      <img
                          alt={t(
                              "Dashboard.LecturerDashboard.GetStarted.PrepareExamination.Title"
                          )}
                          src="/images/example/campla.png"
                      />
                    </td>
                    <td>
                      <b>
                        {t(
                          "Dashboard.LecturerDashboard.GetStarted.PrepareExamination.Title"
                        )}
                      </b>
                      <p>
                        {t(
                          "Dashboard.LecturerDashboard.GetStarted.PrepareExamination.Description"
                        )}
                      </p>
                    </td>
                    <td width="50px">
                      <a href={window.helpVideos.lecturer.prepareExamination} target="_blank">
                        <Button
                            className="btn btn-green"
                            size="sm"
                        >
                          <FontAwesomeIcon icon={faLink} />
                        </Button>
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td width="80px">
                      <img
                          alt={t(
                              "Dashboard.LecturerDashboard.GetStarted.ExaminationFiles.Title"
                          )}
                          src="/images/example/campla.png"
                      />
                    </td>
                    <td>
                      <b>
                        {t(
                          "Dashboard.LecturerDashboard.GetStarted.ExaminationFiles.Title"
                        )}
                      </b>
                      <p>
                        {t(
                          "Dashboard.LecturerDashboard.GetStarted.ExaminationFiles.Description"
                        )}
                      </p>
                    </td>
                    <td width="50px">
                      <a href={window.helpVideos.lecturer.examinationFiles} target="_blank">
                        <Button
                            className="btn btn-green"
                            size="sm"
                        >
                          <FontAwesomeIcon icon={faLink} />
                        </Button>
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td width="80px">
                      <img
                          alt={t(
                              "Dashboard.LecturerDashboard.GetStarted.StudentFileProposals.Title"
                          )}
                          src="/images/example/campla.png"
                      />
                    </td>
                    <td>
                      <b>
                        {t(
                          "Dashboard.LecturerDashboard.GetStarted.StudentFileProposals.Title"
                        )}
                      </b>
                      <p>
                        {t(
                          "Dashboard.LecturerDashboard.GetStarted.StudentFileProposals.Description"
                        )}
                      </p>
                    </td>
                    <td width="50px">
                      <a href={window.helpVideos.lecturer.studentFileProposals} target="_blank">
                        <Button
                            className="btn btn-green"
                            size="sm"
                        >
                          <FontAwesomeIcon icon={faLink} />
                        </Button>
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td width="80px">
                      <img
                          alt={t(
                              "Dashboard.LecturerDashboard.GetStarted.DoExamination.Title"
                          )}
                          src="/images/example/campla.png"
                      />
                    </td>
                    <td>
                      <b>
                        {t(
                          "Dashboard.LecturerDashboard.GetStarted.DoExamination.Title"
                        )}
                      </b>
                      <p>
                        {t(
                          "Dashboard.LecturerDashboard.GetStarted.DoExamination.Description"
                        )}
                      </p>
                    </td>
                    <td width="50px">
                      <a href={window.helpVideos.lecturer.doExamination} target="_blank">
                        <Button
                            className="btn btn-green"
                            size="sm"
                        >
                          <FontAwesomeIcon icon={faLink} />
                        </Button>
                      </a>
                    </td>
                  </tr>
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default withTranslation()(LecturerDashboard);
